import React from 'react'
import { Row, Col} from 'antd'
import moment from 'moment'
import CardTotalCost from '../Cards/card-total-cost'
import CardForecast from '../Cards/card-forecast'
import CardStorageUsage from '../Cards/card-storage-usage'
import CardBucketCount from '../Cards/card-bucket-count'
import './overview-cards.scss'

export default ({selectedAccount, selectedMonth, productsTotalCost}) => {
    let forecast = 0
    let totalCost = 0

    if(selectedAccount)
    {

        productsTotalCost.map((product) => {
            totalCost += product.total_cost
        })
        totalCost = totalCost ? totalCost.toFixed(2) : 0

        let dayOfMonth = moment().date()
        let dayInMonth = moment().daysInMonth()
        let currentMonth = moment().month() + 1

        if(currentMonth > selectedMonth)
        {
            forecast  = totalCost
        }
        else
        {
            forecast = (totalCost * (dayInMonth/dayOfMonth)).toFixed(2)
        }

    }
    return (
    <div>
        <Row gutter={30} className="cards-container">
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <div>
                    <CardBucketCount bucketCount={selectedAccount && selectedAccount.storages.length} />
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <div>
                    <CardStorageUsage storageUsage={selectedAccount && selectedAccount.total_bytes_used} />
                </div>

            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <div>
                    <CardForecast forecast={forecast} />
                </div>

            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <div>
                    <CardTotalCost title="Total Cost" description="" totalCost={selectedAccount && totalCost} />
                </div>
            </Col>
        </Row>
    </div>
)}
